import Button from "components/common/button/Button";

type FormActionsPropsType = {
  disableInputs?: boolean;
};

const FormActions = (props: FormActionsPropsType) => {
  return (
    <fieldset className="form-actions">
      <Button disabled={props.disableInputs} type="submit" title="button.submit" theme="primary">
        <span>Submit</span>
      </Button>
      <Button type="reset" disabled={props.disableInputs} title="button.reset">
        <span>Reset</span>
      </Button>
    </fieldset>
  );
};
export default FormActions;
